// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselSwiperController from "./carousel_swiper_controller"
application.register("carousel-swiper", CarouselSwiperController)

import CustomRadioController from "./custom_radio_controller"
application.register("custom-radio", CustomRadioController)

import FooterSubMenusController from "./footer_sub_menus_controller"
application.register("footer-sub-menus", FooterSubMenusController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocaleController from "./locale_controller"
application.register("locale", LocaleController)

import MobileNavOpenController from "./mobile_nav_open_controller"
application.register("mobile-nav-open", MobileNavOpenController)

import OneTrustController from "./one_trust_controller"
application.register("one-trust", OneTrustController)

import OpenToggleController from "./open_toggle_controller"
application.register("open-toggle", OpenToggleController)

import TableBreakSpacesController from "./table_break_spaces_controller"
application.register("table-break-spaces", TableBreakSpacesController)

import VideoStopperController from "./video_stopper_controller"
application.register("video-stopper", VideoStopperController)
